import { Util } from '../utils/Commom';
function setEvent(options, chart) {
    var newOptions = Util.omit(options, ['onClick']);
    if (options.onClick) {
        newOptions.onClick = function (obj) {
            options.onClick(obj, chart);
        };
    }
    return newOptions;
}
export var process = function (chart, config) {
    var cPieLabel = Util.deepClone(config.pieLabel);
    if (Util.isNil(cPieLabel)) {
        return;
    }
    return chart.pieLabel(setEvent(cPieLabel, chart));
};
//# sourceMappingURL=setPieLabelConfig.js.map